import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { m as a } from "./tss-DN0acMKN.mjs";
import { M as n, d as l } from "./constants-CnFYFetN.mjs";
import { G as d } from "./Grid-YOVcEbCu.mjs";
const x = a()(({ spacing: o, mode: s }, { margin: t }) => ({
  root: {
    alignItems: "flex-end",
    display: "flex",
    marginBottom: o(2),
    outline: s === n.Dye ? `1px solid ${l.main}` : void 0,
    "&>:not(:last-child)": {
      marginRight: o(1)
    },
    ...t === "none" && {
      marginBottom: 0
    },
    ...t === "dense" && {
      marginBottom: o(1)
    }
  }
})), y = ({ children: o, className: s, margin: t = "normal", ...r }) => {
  const { classes: e, cx: m } = x({ margin: t });
  return /* @__PURE__ */ i.jsx(d, { className: m(s, e.root), item: !0, xs: 12, ...r, "data-fabric-component": "GridRow", children: o });
};
export {
  y as G
};
//# sourceMappingURL=grid-row-D1eZQbHo.mjs.map
